import { runtimeConfig } from "../config";

export function Brand() {
  return (
    <div class="flex items-center gap-2">
      <img
        class="w-[3rem]"
        src={`${runtimeConfig.assetOrigin}/logo.png`}
        alt=""
      />
      <div>
        <p class="roboto700 text-2xl">nopixel</p>
        <p>Los Santos</p>
      </div>
    </div>
  );
}
